import { useState, type FormEvent } from 'react'
import { createFileRoute, Link } from '@tanstack/react-router'
import { api } from '../api/client'
import { Button } from '../components/ui/button'
import { Input } from '../components/ui/input'

// DIS-31: request a password-reset email. Always succeeds from the user's
// point of view so the page can't be used to probe for accounts.
export const Route = createFileRoute('/forgot')({
  component: ForgotPage,
})

function ForgotPage() {
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    const email = String(new FormData(e.currentTarget).get('email') ?? '')
    const { response } = await api.POST('/auth/forgot', { body: { email } })
    setBusy(false)
    if (response.ok) setDone(true)
    else if (response.status === 429) setError('Too many attempts. Try again in a minute.')
    else setError(`Something went wrong (${response.status}).`)
  }

  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="w-full max-w-sm space-y-4 rounded-lg border border-border bg-bg-muted p-6">
        <h1 className="text-lg font-semibold">Reset your password</h1>
        {done ? (
          <p className="text-sm text-fg-muted">If that address has an account, a reset link is on its way. It's valid for one hour.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-fg-muted">Enter your email and we'll send a link to choose a new password.</p>
            <Input name="email" type="email" required placeholder="you@example.com" autoComplete="username" autoFocus />
            {error && (
              <p role="alert" className="text-sm text-danger">
                {error}
              </p>
            )}
            <Button type="submit" className="w-full" disabled={busy}>
              {busy ? 'Sending…' : 'Send reset link'}
            </Button>
          </form>
        )}
        <p className="text-sm">
          <Link to="/login" className="text-accent underline">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  )
}
